import type { ProductSchema } from '@integration-layer/.nuxt/armani/product-schema'

type GetProductsByTagParams = {
  tag: string
  brand?: string
  gender?: string
  excludeObjectId?: string
  hitsPerPage?: number
}

/**
 * Fetches Algolia products that share a given PDP tag, brand and gender.
 * Excludes the current product when `excludeObjectId` is provided.
 */
export const useProductsByTag = () => {
  const algoliaIndex = useAppConfig().currentAlgoliaIndex

  const getProductsByTag = async ({
    tag,
    brand,
    gender,
    excludeObjectId,
    hitsPerPage = 12,
  }: GetProductsByTagParams) => {
    if (!tag.trim()) return [] as ProductSchema[]

    return $fetch<ProductSchema[]>(`/api/getProductsByTag/${algoliaIndex}`, {
      query: {
        tag,
        brand,
        gender,
        excludeObjectId,
        hitsPerPage,
      },
    })
  }

  return { getProductsByTag }
}
